import type { UserProfile } from '~/types';
import { Avatar, AvatarFallback } from '~/components/ui/avatar';
import { Button } from '../../components/ui/button';
import { Loader2 } from 'lucide-react';

interface Props {
  isLoading: boolean;
  userProfiles: UserProfile[];
  onUnregister: (userProfile: UserProfile) => void;
}

export function AlreadyRegistered({
  userProfiles,
  onUnregister,
  isLoading,
}: Props) {
  return (
    <div className="flex flex-col gap-2">
      {userProfiles.map((userProfile) => {
        return (
          <div
            key={userProfile.id}
            className="flex h-16 w-full select-none items-center justify-between rounded-md border bg-secondary p-4 text-secondary-foreground"
          >
            <div className="flex items-center gap-3">
              <Avatar>
                <AvatarFallback className="bg-primary text-primary-foreground">
                  {userProfile.firstName.charAt(0)}
                  {userProfile.lastName.charAt(0)}
                </AvatarFallback>
              </Avatar>
              <span className="text-lg">
                {userProfile.firstName} {userProfile.lastName}
              </span>
            </div>
            <div className="flex items-center justify-center gap-4 text-xs">
              <Button
                size="sm"
                onClick={() => onUnregister(userProfile)}
                disabled={isLoading}
              >
                {!isLoading && 'Unregister'}
                {isLoading && <Loader2 size={16} className="animate-spin" />}
              </Button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
